import React, { useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import Signup from './Signup';
import Modal from 'react-bootstrap/Modal';

export default function Login() {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <div className='login-page'>
        <h3>Login</h3>
        <Form.Control type="email" placeholder="name@example.com" />
        <Form.Control type="password" placeholder="Password" />
        <Button>Login</Button>
        <span>
        <a href='#'>Forgot Password ?</a>
        <span> /</span>
        <Button variant='text' style={{color:'#0d6efd'}} onClick={handleShow}>Signup</Button>
        </span>
        <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Signup</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
          <Signup/>
          </div>
          </Modal.Body>
        </Modal>
    </div>
  )
}
